import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRoles?: string[]; // 新增：所需角色
  requireAll?: boolean; // 新增：是否需要满足所有角色
}

export function ProtectedRoute({
  children,
  requiredRoles = [],
  requireAll = false,
}: ProtectedRouteProps) {
  const { isAuthenticated, user, loading } = useAuth();
  const location = useLocation();
  // 处理加载状态
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900" />
      </div>
    );
  }

  // 如果用户未登录，重定向到登录页面
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 验证角色权限
  if (requiredRoles.length > 0 && user?.roles) {
    const hasRequiredRoles = requireAll
      ? requiredRoles.every((role) =>
          user.roles.some((userRole) => userRole.code === role)
        )
      : requiredRoles.some((role) =>
          user.roles.some((userRole) => userRole.code === role)
        );

    if (!hasRequiredRoles) {
      return <Navigate to="/403" replace />;
    }
  }

  return <>{children}</>;
}
